/*
 * LocaleToggle Messages
 *
 * This contains all the text for the Footer component.
 */
import {defineMessages} from 'react-intl';

export const scope = 'app.components.Footer';

export default defineMessages({
    attention: {
        id: `${scope}.attention`,
        defaultMessage: 'Attention',
    },
    firstDisclaimer: {
        id: `${scope}.firstDisclaimer`
    },
    secondDisclaimer: {
        id: `${scope}.secondDisclaimer`
    },
    thirdDisclaimer: {
        id: `${scope}.thirdDisclaimer`
    },
    fourthDisclaimer: {
        id: `${scope}.fourthDisclaimer`
    },
    fifthDisclaimer: {
        id: `${scope}.fifthDisclaimer`
    },
    sixthDisclaimer: {
        id: `${scope}.sixthDisclaimer`
    },
    seventhDisclaimer: {
        id: `${scope}.seventhDisclaimer`
    },
    eightDisclaimer: {
        id: `${scope}.eightDisclaimer`
    },
    ninthDisclaimer: {
        id: `${scope}.ninthDisclaimer`
    },
    career: {
        id: `${scope}.career`,
        defaultMessage: 'Career',
    },
    blog: {
        id: `${scope}.blog`,
        defaultMessage: 'Blog'
    },
    terms: {
        id: `${scope}.terms`,
        defaultMessage: 'Terms of Use'
    },
    privacyPolicy: {
        id: `${scope}.privacyPolicy`,
        defaultMessage: 'Privacy Policy'
    },
    callUs: {
        id: `${scope}.callUs`,
        defaultMessage: 'Call Us'
    }
});



// WEBPACK FOOTER //
// ./src/components/Footer/messages.js